import { Megaphone } from "lucide-react";

export function AnnouncementBar({ konten }) {
  if (!konten?.pengumuman_aktif || !konten?.pengumuman_teks) return null;
  const inner = (
    <div className="flex items-center justify-center gap-2 px-3 md:px-4 py-2 md:py-0 md:h-10 min-h-[36px]">
      <Megaphone size={15} strokeWidth={1.6} className="shrink-0 text-[#FF6B1A]" />
      <span className="text-center text-xs md:text-sm font-medium text-white">{konten.pengumuman_teks}</span>
    </div>
  );
  return (
    <div className="hsv5-on-dark bg-[#1D1D1F] w-full" data-testid="announcement-bar">
      {konten.pengumuman_link ? (
        <a href={konten.pengumuman_link} className="block" data-testid="announcement-link">{inner}</a>
      ) : inner}
    </div>
  );
}
